import { render, staticRenderFns } from "./bulkDomainDeletionModal.vue?vue&type=template&id=39dbc96a&scoped=true"
import script from "./bulkDomainDeletionModal.vue?vue&type=script&lang=js"
export * from "./bulkDomainDeletionModal.vue?vue&type=script&lang=js"
import style0 from "./bulkDomainDeletionModal.vue?vue&type=style&index=0&id=39dbc96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dbc96a",
  null
  
)

export default component.exports